angular.module('gm.modals')
.controller('ActionsModalController', ActionsModalController);

function ActionsModalController(
  $scope,
  close,
  update,
  title,
  filters,
  actions,
  data
) {
  'ngInject';

  const vm = this;

  vm.close = close;
  vm.title = title;
  vm.filters = filters;
  vm.actions = actions;
  vm.cancel = close;
  vm.update = close;
  vm.executeAction = executeAction;

  activate();

  function activate() {
    vm.values = {};
    vm.filters.forEach((filter) => {
      vm.values[filter.field] = filter.value;
    });
    $scope.$watchCollection('modalCtrl.values', updateValues);
  }

  function executeAction(action) {
    if (action.disabled) {
      close();
    } else {
      close({
        action: action.id,
        data,
      });
    }
  }

  function updateValues(values) {
    update(values);
  }
}
